import React from "react";
import { Box, Typography, Card, Grid } from "@mui/material";
import { cardStyles } from "../../styles/CustomCss";

const SummaryCard = ({ count, title, description, backgroundColor }) => {
  return (
    <Grid item xs={12} sm={6} md={4}>
      <Card
        sx={{
          ...cardStyles,
          backgroundColor: backgroundColor,
          borderRadius: "12px",
          padding: 2,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          transition: "transform 0.3s, box-shadow 0.3s",
          "&:hover": {
            boxShadow: 6,
            transform: "scale(1.05)",
          },
          fontFamily: "Poppins, sans-serif",
        }}
      >
        {/* Left Side: Count */}
        <Typography
          variant="h1"
          sx={{
            fontWeight: "normal",
            color: "#fff",
            textAlign: "center",
            flex: 1,
            fontSize: {
              xs: "1.5rem", // Small font for extra-small screens (phones)
              sm: "2rem", // Medium font for small screens (tablets)
              md: "3rem", // Large font for medium screens (laptops)
              lg: "4rem", // Larger font for large screens (desktops)
            },
          }}
        >
          {count}
        </Typography>

        {/* Right Side: Stack */}
        <Box sx={{ flex: 2, textAlign: "left" }}>
          <Typography
            variant="h6"
            sx={{
              fontFamily: "Poppins, sans-serif",
              fontWeight: "bold",
              color: "#fff",
              mb: 1,
            }}
          >
            {title}
          </Typography>
          <Typography
            variant="body2"
            color="#000"
            sx={{ mb: 1, fontFamily: "Poppins, sans-serif" }}
          >
            {description}
          </Typography>
          <Box
            sx={{
              borderTop: "2px solid rgba(255, 255, 255, 0.6)",
              marginTop: 1,
              paddingTop: 1,
            }}
          >
            <Typography
              variant="caption"
              color="white"
              sx={{ fontFamily: "Poppins, sans-serif" }}
            >
              Updated as of {new Date().toLocaleDateString()}
            </Typography>
          </Box>
        </Box>
      </Card>
    </Grid>
  );
};

export default SummaryCard;
